<template>
  <div class="lp-block-wrapper">
    <div class="lp-block-hero">
      <div class="lp-block-container">
        <div class="lp-block-badge">沼津市にお住まいの方へ</div>
        <div class="lp-block-main-title">
          処分に困ったアルミホイール付きタイヤを<br>
          <span class="lp-block-highlight">費用0円</span>でスマートに無人回収
        </div>
        <div class="lp-block-sub-title">
          溝がなくても、古くても問題ありません。アルミホイールが付いていればどんな車種でも対象です。沼津エリア内にある「指定回収場所」へ直接お持ち込みいただくことで、完全無料で引き取ります。
          <br>※鉄（スチール）ホイールやタイヤのみは対象外
        </div>
      </div>
    </div>

    <div class="lp-block-section">
      <div class="lp-block-container">
        <div class="lp-block-section-title">ご利用の流れ</div>
        
        <div class="lp-block-steps-flow">
          <div class="lp-block-step-item">
            <span class="lp-block-step-num">01</span>
            <div class="lp-block-step-title">LINEで写真を送る</div>
            <div class="lp-block-step-desc">公式LINEを追加し、処分したいタイヤの写真をスマホで送るだけ。</div>
          </div>
          
          <div class="lp-block-step-item">
            <span class="lp-block-step-num">02</span>
            <div class="lp-block-step-title">場所の共有</div>
            <div class="lp-block-step-desc">確認後、折り返し沼津エリア内にある「詳しい無人回収場所」をご案内します。</div>
          </div>
          
          <div class="lp-block-step-item">
            <span class="婚lp-block-step-num">03</span>
            <div class="lp-block-step-title">好きな時間に置いて完了</div>
            <div class="lp-block-step-desc">何時でもお好きなタイミングでお持ち込み可能です。完全無人受付のため、対面の立会いや挨拶も一切不要です。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="lp-block-section-cta">
      <div class="lp-block-container">
        <div class="lp-block-cta-text">近隣のご迷惑にならないよう静かに置いていただければ、24時間いつでも大歓迎です。</div>
        <a :href="lineUrl" target="_blank" class="lp-block-btn-cta">
          LINEで無料回収を申し込む
        </a>
      </div>
    </div>

    <!-- 🛠️ フッター：文字を画像に置き換える修正を行いました -->
    <div class="lp-block-footer">
      <div class="lp-block-container">
        <div class="lp-block-footer-img-wrapper">
          <img src="@/assets/footer-text.png" alt="" class="lp-block-footer-img">
        </div>
      </div>
    </div>

    <div class="lp-block-fixed-footer">
      <a :href="lineUrl" target="_blank" class="lp-block-btn-footer-cta">
        LINEで無料回収を依頼する
      </a>
    </div>
  </div>
</template>


<script>
export default {
  name: 'NumazuKaishuuView',
  data() { return { lineUrl: 'https://lin.ee/sFKSEtZ' } },
  mounted() {
    // 🌟 沼津市で検索した人にバチッと届くタイトルを固定
    document.title = '【沼津市】処分に困ったアルミホイール付きタイヤの無料回収 - カツマタ'
  }
}
</script>



<style scoped>
/* 前回のスマート・洗練版スタイルをそのまま維持 */
.lp-block-wrapper {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  color: #333333 !important;
  background-color: #ffffff !important;
  line-height: 1.7 !important;
  padding-bottom: 100px !important;
  position: relative !important;
  display: block !important;
  width: 100% !important;
  min-height: 100vh !important;
  text-align: center !important;
  margin: 0 !important;
  padding-top: 0 !important;
}

.lp-block-wrapper div, 
.lp-block-wrapper a, 
.lp-block-wrapper img,
.lp-block-wrapper span {
  box-sizing: border-box !important;
  float: none !important;
  position: relative !important;
  height: auto !important;
  max-height: none !important;
  min-height: 0 !important;
  top: auto !important;
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
}

.lp-block-container {
  max-width: 480px !important;
  margin: 0 auto !important;
  padding: 0 24px !important;
  width: 100% !important;
  display: block !important;
}

.lp-block-hero {
  background-color: #f2f8f6 !important;
  padding: 60px 0 50px 0 !important;
  display: block !important;
  width: 100% !important;
}

.lp-block-badge {
  background-color: #e2f0ec !important;
  color: #2e7d6b !important;
  padding: 4px 14px !important;
  border-radius: 4px !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  display: inline-block !important;
  margin: 0 auto 20px auto !important;
  letter-spacing: 0.05em !important;
}

.lp-block-main-title {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
  line-height: 1.5 !important;
  margin: 0 0 20px 0 !important;
  color: #1a3a34 !important;
}

.lp-block-highlight {
  color: #2e7d6b !important;
  font-size: 1.9rem !important;
  font-weight: 800 !important;
  border-bottom: 3px solid #2e7d6b !important;
  display: inline-block !important;
  margin: 0 2px !important;
  padding-bottom: 2px !important;
}

.lp-block-sub-title {
  font-size: 0.9rem !important;
  margin: 0 auto !important;
  color: #4a5c56 !important;
  display: block !important;
  text-align: left !important;
}

.lp-block-section {
  padding: 50px 0 30px 0 !important;
  display: block !important;
  width: 100% !important;
}

.lp-block-section-title {
  font-size: 1.3rem !important;
  margin: 0 0 30px 0 !important;
  font-weight: 700 !important;
  color: #1a3a34 !important;
  display: block !important;
  letter-spacing: 0.05em !important;
}

.lp-block-steps-flow {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
  width: 100% !important;
}

.lp-block-step-item {
  background: #ffffff !important;
  padding: 24px 20px 24px 60px !important;
  border-radius: 8px !important;
  text-align: left !important;
  border: 1px solid #eef2f1 !important;
  box-shadow: 0 4px 12px rgba(46, 125, 107, 0.03) !important;
  display: block !important;
  width: 100% !important;
}

.lp-block-step-num {
  font-size: 1.3rem !important;
  font-weight: 700 !important;
  color: #2e7d6b !important;
  position: absolute !important;
  top: 24px !important;
  left: 20px !important;
  line-height: 1 !important;
  display: inline-block !important;
}

.lp-block-step-title {
  margin: 0 0 6px 0 !important;
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  color: #1a3a34 !important;
  display: block !important;
}

.lp-block-step-desc {
  margin: 0 !important;
  font-size: 0.88rem !important;
  color: #666666 !important;
  display: block !important;
  line-height: 1.5 !important;
}

.lp-block-section-cta {
  padding: 10px 0 40px 0 !important;
  display: block !important;
  width: 100% !important;
}

.lp-block-cta-text {
  font-weight: 600 !important;
  color: #2e7d6b !important;
  margin: 0 0 15px 0 !important;
  font-size: 0.95rem !important;
  display: block !important;
}

.lp-block-btn-cta {
  display: inline-block !important;
  background-color: #2e7d6b !important;
  color: #ffffff !important;
  padding: 16px 20px !important;
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  border-radius: 6px !important;
  text-decoration: none !important;
  box-shadow: 0 4px 12px rgba(46, 125, 107, 0.15) !important;
  width: 100% !important;
  letter-spacing: 0.03em !important;
}

/* 🎨 画像に置き換えたフッターの最適化スタイル */
.lp-block-footer {
  background-color: #fafbfc !important;
  padding: 35px 0 !important;
  border-top: 1px solid #edf1f0 !important;
  display: block !important;
  width: 100% !important;
}

.lp-block-footer-img-wrapper {
  max-width: 360px !important;
  margin: 0 auto !important;
  width: 100% !important;
}

.lp-block-footer-img {
  width: 100% !important;
  height: auto !important;
  display: block !important;
  opacity: 0.8 !important; /* 文字テキストの時の色合い（#888888）に近い落ち着いたトーンを再現 */
}

.lp-block-fixed-footer {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100% !important;
  background: #ffffff !important;
  padding: 14px 20px !important;
  box-shadow: 0 -4px 16px rgba(0,0,0,0.06) !important;
  z-index: 1000 !important;
  display: block !important;
}

.lp-block-btn-footer-cta {
  display: block !important;
  background-color: #2e7d6b !important;
  color: #ffffff !important;
  text-align: center !important;
  padding: 14px 0 !important;
  font-weight: 700 !important;
  font-size: 1.05rem !important;
  border-radius: 6px !important;
  text-decoration: none !important;
  width: 100% !important;
}

@media (min-width: 769px) {
  .lp-block-fixed-footer {
    display: none !important;
  }
}
</style>
